import { jsx as _jsx } from "react/jsx-runtime";
import { createColumnHelper } from '@tanstack/react-table';
import { ModuleOrApplicationLinkRenderer } from '../ModulesDependencies/renderers/ModuleOrApplicationLinkRenderer';
import { RemoteConsumesFilesLinksRenderer } from './RemoteConsumesFilesLinksRenderer';
const columnHelper = createColumnHelper();
export const configureColumnDefs = (organization, project, application)=>{
    if (!organization || !project) {
        return [];
    }
    return [
        columnHelper.accessor((row)=>row, {
            id: 'name',
            header: ()=>'Name',
            cell: (inf)=>/*#__PURE__*/ _jsx(ModuleOrApplicationLinkRenderer, {
                    organization: organization,
                    project: project,
                    application: application,
                    value: inf.getValue().name
                })
        }),
        columnHelper.accessor((row)=>row, {
            id: 'file',
            header: ()=>'File',
            cell: (inf)=>/*#__PURE__*/ _jsx(RemoteConsumesFilesLinksRenderer, {
                    value: inf.getValue().file
                })
        })
    ];
};
export const convertToRowData = (module)=>{
    return module.consumedBy.map((consumeItem)=>({
            name: consumeItem.name,
            applicationName: consumeItem.applicationID,
            file: consumeItem.usedIn.map((param)=>{
                let { file, url } = param;
                return {
                    name: file,
                    url
                };
            }),
            type: consumeItem.name ? 'module' : 'application'
        }));
};
